export default __webpack_public_path__ + "static/carousel-3-3b0c910706a70f757f3303761bb9de04.jpg";